import React, { createContext, useContext, useRef } from "react";
import { useStore } from "zustand";
import { createListadoStateStore } from "./ListadoStateStore";

const ListadoStateContext = createContext(null);

export const ListadoStateProvider = ({
  children,
  initialValues = {},
  store: providedStore,
}) => {
  const storeRef = useRef();

  if (providedStore) {
    storeRef.current = providedStore;
  } else if (!storeRef.current) {
    storeRef.current = createListadoStateStore(initialValues);
  }

  return (
    <ListadoStateContext.Provider value={storeRef.current}>
      {children}
    </ListadoStateContext.Provider>
  );
};

export const useListadoStateStore = (selector) => {
  const store = useContext(ListadoStateContext);

  if (!store) {
    throw new Error(
      "useListadoStateStore debe usarse dentro de un ListadoStateProvider"
    );
  }

  return useStore(store, selector);
};

export const useListadoStateApi = () => {
  const store = useContext(ListadoStateContext);

  if (!store) {
    throw new Error(
      "useListadoStateApi debe usarse dentro de un ListadoStateProvider"
    );
  }

  return store;
};

export default ListadoStateContext;
